var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4786FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8548 17.655C12.6248 17.885 12.3398 18 11.9998 18C11.6598 18 11.3748 17.885 11.1448 17.655C10.9148 17.425 10.7998 17.14 10.7998 16.8C10.7998 16.46 10.9148 16.175 11.1448 15.945C11.3748 15.715 11.6598 15.6 11.9998 15.6C12.3398 15.6 12.6248 15.715 12.8548 15.945C13.0848 16.175 13.1998 16.46 13.1998 16.8C13.1998 17.14 13.0848 17.425 12.8548 17.655Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1998 13.2H10.7998V6H13.1998V13.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.73d406508f35abe27c17bece48d54d8f.svg";
export { ForwardRef as ReactComponent };